module.exports = __webpack_public_path__ + "img/album15_14.333cc64c.jpg";